import { Locales } from "i18n/config"
import WorkingHour, { WorkingHourData } from "./workingHour"
import { ContractChangeMetaData, IPostContractPayload, ContractRange } from "./contract"
import Correction from "./correction"

export enum Roles {
  Planner = "Planner",
  User = "User",
  Support = "Support",
  HROfficer = "HROfficer",
  Devops = "Devops",
  Tester = "Tester",
}

export enum Status {
  Active = "active",
  Inactive = "inactive",
}

export type UserFunction = {
  _id?: string
  id?: string
  name: string
  deleted_at: Date | null
}

export enum ContractTypes {
  PAYROLL = "payroll",
  EXTERNAL = "external",
}

export enum ScheduleTypes {
  FIXED = "fixed",
  FLEXIBLE = "flexible",
}

export default interface User {
  id: string
  first_name: string
  last_name: string
  email: string
  avatar?: string
  created_at?: string
  updated_at?: string
  roles?: Roles[]
  function?: UserFunction
  contract_type?: ContractTypes
  contracted_hours?: number
  contract_start_date?: string
  planned_hours?: string
  contract_contract_balancehours?: string
  contract_change_note?: ContractChangeMetaData
  contract_range: ContractRange
  birthday?: string
  street_name?: string
  zipcode?: string
  city?: string
  locale: Locales
  preferable_working_hours?: WorkingHour[]
  sdworx_employee_number: string
  settings: {
    created_at: string
    employee_id: string
    hide_time: boolean
    hide_warnings: boolean
    hide_weekend: boolean
    horizontal_scale: number
    id: number
    updated_at: string
  }
}

export type GetUserSettings = Pick<
  User["settings"],
  "hide_weekend" | "hide_time" | "hide_warnings" | "horizontal_scale"
>

export type PatchUserPayload = Omit<User, "settings">

export type CurrentToken = Pick<User, "id" | "roles"> & {
  system_roles?: Roles[]
}

export type UserNameWithName = Pick<User, "first_name" | "last_name">
export type UserNameWithNameAndFunction = Pick<User, "first_name" | "last_name" | "function">

export interface WorkingHoursPutPayload {
  userId: string
  data: WorkingHourData[]
}

export interface WorkingHoursDeletePayload {
  id: string
  data: WorkingHour[]
}

export interface IPostUserPayload {
  correction?: Correction | null
  first_name: string
  last_name: string
  email: string
  birthday?: string
  street_name?: string
  locale?: Locales
  function?: UserFunction
  roles: Roles[]
  contract?: IPostContractPayload
  contract_contract_balancehours?: string
  sdworx_employee_number?: string
  preferable_working_hours?: WorkingHour[]
}

export type IPatchUserPayloadValue = string | string[] | number | UserFunction | undefined
export interface IPatchUserPayload {
  field: string
  value: IPatchUserPayloadValue
}
